import { StyleSheet } from 'react-native';
import { neutrals, text } from 'src/theme/colors';

export const style = StyleSheet.create({
  dropdownContainer: {
    width: 200,
    borderRadius: 25,
    paddingTop: 16,
    backgroundColor: neutrals.white,
    shadowColor: neutrals.black,
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 43,
  },
  actionsWrapper: {
    gap: 6,
    paddingBottom: 6,
  },
  action: {
    width: '100%',
    paddingVertical: 12,
    paddingHorizontal: 24,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 8,
  },
  counter: {
    borderTopWidth: 1,
    borderColor: neutrals.neutralGrays.aluminium,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 4,
    paddingVertical: 21,
  },
  actionIcon: {
    width: 22,
    height: 22,
  },
  actionText: {
    fontWeight: 400,
    fontSize: 16,
    lineHeight: 24,
    color: text.secondaryText,
  },
  iconCounter: {
    width: 13,
    height: 13,
  },
  countText: {
    fontWeight: 700,
    fontSize: 14,
    lineHeight: 21,
    color: neutrals.neutralGrays.graphite,
    minWidth: 30,
    textAlign: 'center',
  },
  selectedButton: {
    position: 'absolute',
    zIndex: 3,
    borderRadius: 20,
    padding: 6,
    backgroundColor: neutrals.white,
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 13,
  },
  icon: {
    width: 18,
    height: 18,
    color: neutrals.white,
  },
  positionRight: {
    left: -10,
    top: -13,
  },
  positionLeft: {
    right: -10,
    top: -13,
  },
});
